<p-toolbar class="shipment-detail-toolbar">
    <ng-template #start>
        <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" (onClick)="goBack()" />
    </ng-template>
    <ng-template #center>
        <h3 class="p-toolbar-title">Shipment Details</h3>
    </ng-template>    
</p-toolbar>

<div class="shipment-detail-container" *ngIf="(shipment() | json) != '{}'">
    <div class="pro-detail-container">
        <p-card>
            <div class="pro-detail-content">
                <p class="pro-number-title">LOAD ID</p>
                <p class="pro-number">#{{shipment().proNumber}}</p>
                <p-chip class="chip-status" [label]="shipment().deliveryStatus.status" />
            </div>
        </p-card>
    </div>

    <div class="timeline-container">
        <p class="timeline-title">Delivery Timeline</p>
        <p-timeline class="timeline-shimpent-history" [value]="shipmentHistory()" align="left">
            <ng-template #marker let-event>
                <span class="timeline-marker">
                    <i [class]=" shipmentHistory().indexOf(event) == 0 ? 'pi pi-box' : 'pi pi-chevron-circle-down'"></i>
                </span>
            </ng-template>
            <ng-template #content let-event let-index>
                <p class="timeline-content-title">{{event.deliveryStatus.status}}</p>
                <p class="timeline-content-subtitle">{{event.updatedDate | date:'mediumDate'}} • {{event.updatedDate | date:'shortTime'}}</p>
                <div class="address-container" *ngIf="event.address && (event.address | json) != '{}'">
                    <a class="address-link" [href]="getMapUrl(event.address)" target="_blank'">                
                        <span *ngIf="event.address.label">{{ event.address.label }}</span>           
                    </a>
                </div>
            </ng-template>
        </p-timeline>
    </div>

    <div class="update-status-container">
        <p-button (onClick)="openDeliveryEvidence()" class="update-status-button" label="Update Status"/>
    </div>
</div>


